import { createSelector, DefaultProjectorFn, MemoizedSelector } from '@ngrx/store';

import { AppState } from '../app.state';

import { SearchListState } from './search.state';

export namespace SearchSelectors {
  export const searchList = (state: AppState): SearchListState => state.searchList;

  export function getState(): MemoizedSelector<
    AppState,
    SearchListState,
    DefaultProjectorFn<SearchListState>
  > {
    return createSelector(searchList, (state: SearchListState) => state);
  }
}
